module.exports = __webpack_public_path__ + "img/触发质量统计扫描.7f383813.svg";